module.exports = __webpack_public_path__ + "71d53eb87f9e836ca0425dd7b54d6e19.pdf";